import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode } from "vue";
var _hoisted_1 = { class: "histogram-renderer" };
var _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "spacer" }, null, -1 /* HOISTED */);
var _hoisted_3 = { class: "histogram-renderer__inner" };
var _hoisted_4 = { class: "histogram-renderer__items" };
var _hoisted_5 = {
    key: 0,
    class: "histogram-renderer__year paragraph-body"
};
var _hoisted_6 = {
    key: 1,
    class: "histogram-renderer__year-empty"
};
var _hoisted_7 = /*#__PURE__*/ _createElementVNode("div", { class: "spacer" }, null, -1 /* HOISTED */);
import { computed } from 'vue';
import HistogramItem from '../HistogramItem/HistogramItem.vue';
import convertPriceResponse from '../../lib/convertPriceResponse';
import dayjs from 'dayjs';
import { getAmadeusPriceTotal } from '../../lib/amadeusPriceDisplayTools';
export default /*#__PURE__*/ _defineComponent({
    __name: 'HistogramRenderer',
    props: {
        apiPrices: {},
        activeMonth: {},
        convertedPrices: {},
        urlRenderer: { type: Function }
    },
    emits: ["update:activeMonth"],
    setup: function (__props) {
        var props = __props;
        var convertedPrices = computed(function () {
            if (props.convertedPrices) {
                return props.convertedPrices;
            }
            if (!props.apiPrices) {
                return {
                    prices: {},
                    lowestFoundPrice: undefined,
                    highestFoundPrice: undefined,
                    currencies: undefined,
                };
            }
            return convertPriceResponse(props.apiPrices, 'departureDate');
        });
        var dates = computed(function () {
            return Object.keys(convertedPrices.value.prices).sort(function (a, b) {
                return dayjs(a).isBefore(dayjs(b)) ? -1 : 1;
            });
        });
        var isInActiveMonth = function (date1) {
            var d1 = dayjs(date1);
            var d2 = dayjs(props.activeMonth);
            return d1.year() === d2.year() && d1.month() === d2.month();
        };
        var mapping = computed(function () {
            var _a, _b, _c;
            var mapped = [];
            for (var i = 0; i < dates.value.length; i++) {
                var date = dates.value[i];
                var price = convertedPrices.value.prices[date];
                var total = Math.round(getAmadeusPriceTotal(price, convertedPrices.value.currencies));
                var amount = total.toLocaleString('en-US', { minimumFractionDigits: 0 });
                var currency = price.currencyCode;
                var year = i === 0 || dayjs(date).month() === 0 ? dayjs(date).format('YYYY') : null;
                var month = dayjs(date).format('MMM');
                var isBestPrice = price.total === ((_a = convertedPrices.value.lowestFoundPrice) === null || _a === void 0 ? void 0 : _a.total);
                var size = Math.round((price.total / ((_c = (_b = convertedPrices.value.highestFoundPrice) === null || _b === void 0 ? void 0 : _b.total) !== null && _c !== void 0 ? _c : 1)) *
                    100);
                mapped.push({ date: date, amount: amount, currency: currency, isBestPrice: isBestPrice, size: size, month: month, year: year });
            }
            return mapped;
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mapping.value, function (item, index) {
                            return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "histogram-renderer__item"
                            }, [
                                (item.year)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(item.year), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true),
                                (!item.year)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                                    : _createCommentVNode("v-if", true),
                                _createVNode(HistogramItem, {
                                    "item-size": item.size,
                                    "best-price": item.isBestPrice,
                                    currency: item.currency,
                                    price: item.amount,
                                    "month-label": item.month,
                                    href: _ctx.urlRenderer ? _ctx.urlRenderer(item) : undefined,
                                    selected: _ctx.activeMonth ? isInActiveMonth(item.date) : false,
                                    onClick: function (event) { return _ctx.$emit('update:activeMonth', item.date, event); }
                                }, {
                                    default: _withCtx(function () { return [
                                        (isInActiveMonth(item.date))
                                            ? _renderSlot(_ctx.$slots, "default", {
                                                key: 0,
                                                date: item.date
                                            })
                                            : _createCommentVNode("v-if", true)
                                    ]; }),
                                    _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["item-size", "best-price", "currency", "price", "month-label", "href", "selected", "onClick"])
                            ]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _renderSlot(_ctx.$slots, "terms")
                ]),
                _hoisted_7,
                _renderSlot(_ctx.$slots, "month-large"),
                _renderSlot(_ctx.$slots, "footer")
            ]));
        };
    }
});
